import { Component, OnInit } from "@angular/core";
import { AdminDashboardService } from "src/app/services/admin-dashboard.service";
import { ExcelService } from "src/app/services/excel.service";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { ZpDataService } from "src/app/services/zp-data.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
    selector: "app-delegate-referral",
    templateUrl: "./delegate-referral.component.html",
    styleUrls: ["./delegate-referral.component.scss"],
    standalone: false
})
export class DelegateReferralComponent implements OnInit {
  public isSearching: boolean = false;
  public lastNameSorted: boolean;
  public firstNameSorted: boolean;
  public emailSorted: boolean;
  public delegates: any;
  public sortedUsers: any;
  public sortedUsersArray: any;
  public page: any;
  public dataIsLoaded: boolean;
  public usersFoundArray: any;
  public usersFound: boolean;
  public message: string;
  public searchData: string = '';
  data: any;
  filteredDelegates: any;
  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService,
    private adminApi: AdminDashboardService,
    private ZpDataService: ZpDataService,
    private excelService: ExcelService,
  ) {}

  async ngOnInit() {
    this.isSearching = false;
    await this.loadDelegates();
  }

  async loadDelegates() {
    this.data = await this.adminApi.getPotentialDelegates();
    if (this.data.success) {
      this.delegates = this.data.result;
    }
    console.log(this.delegates);
  }

  searchByLastName(searchData) {
    searchData = this.searchData;
    if (this.searchData) {
      this.isSearching = true;
      const searchTerm = this.searchData.toLowerCase();

      // Filter delegates based on last name
      this.filteredDelegates = this.delegates.filter(delegate =>
        delegate.delegateName.toLowerCase().includes(searchTerm)
      );
    } else {
      // If search input is empty, display all delegates
      this.isSearching = false;
      this.filteredDelegates = this.delegates;
    }
  }

  async sortColumns(columnName) {
    switch (columnName) {
      case "email":
        this.emailSorted = !this.emailSorted;
        if (this.emailSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"email":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"email":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        }
        break;
      case "firstName":
        this.firstNameSorted = !this.firstNameSorted;
        if (this.firstNameSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"firstName":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"firstName":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        }
        break;
      case "lastName":
        this.lastNameSorted = !this.lastNameSorted;
        if (this.lastNameSorted) {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"lastName":-1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        } else {
          this.sortedUsers = await this.ZpDataService.getAllUsers(
            this.page,
            '{"lastName":1}'
          );
          this.sortedUsersArray = this.sortedUsers.users;
          this.delegates = this.sortedUsersArray;
        }
        break;
    }
  }

  exportToExcel(): void {
    // Example usage with a specific column order
    const customColumnOrder: string[] = [
      'delegateName',
      'delegateEmail',
      'delegateRelation',
      'planHolderName',
      'company',
      'delegateCreationDate'
    ];

    this.excelService.exportAsExcelFile(this.delegates, 'Delegates', customColumnOrder);
  }
}